import { render, staticRenderFns } from "./ParametersG20JdList.vue?vue&type=template&id=8cf0063a&scoped=true"
import script from "./ParametersG20JdList.vue?vue&type=script&lang=js"
export * from "./ParametersG20JdList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf0063a",
  null
  
)

export default component.exports